import React, { FC, ReactNode } from 'react';
import { Chip } from 'snacks-design-system';
import styles from './PIEChips.module.scss';

export enum PIEChipModes {
  PRIMARY = 'small',
  OUTLINE = 'outline',
  GHOST = 'ghost',
}

export interface IPIEChipAriaProperty {
  label: string;
  close: string;
  current: string;
}

export interface IPIEChip {
  className?: string;
  children?: ReactNode;
  icon?: ReactNode;
  mode?: PIEChipModes;
  isDisabled?: Boolean;
  isSelected?: Boolean;
  isLoading?: Boolean;
  role?: string;
  aria?: IPIEChipAriaProperty;
  onClick?: () => void;
  onClose?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  iconAsChildren?: ReactNode;
  qaSelector?: string;
}
export const PIEChip: FC<IPIEChip> = (props) => {
  return (
    <Chip className={styles.fazi} {...props}>
      {props.children} {props.iconAsChildren}
    </Chip>
  );
};

export default PIEChip;
